import { useCallback, useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'

import {
  NaiveDateTime,
  recurences,
  RRule,
  rrulestr
} from '@guestgoodie/helpers'

import { RecDate } from './RecDate'
import { RRuleInput } from './RRuleInputs'

interface Props {
  value: GraphQL.RecurrenceFragmentFragment
  onChange: (newRecurrence: GraphQL.RecurrenceFragmentFragment) => void
  showUntil?: boolean
}

export function RecurrenceInput(props: Props) {
  const { value, onChange, showUntil = true } = props

  const startDate = useMemo(
    () => NaiveDateTime.fromNaiveISO(value.startDate),
    [value.startDate]
  )

  const duration = useMemo(() => value.duration, [value.duration])
  const rrule = useMemo(() => rrulestr(value.rrule), [value.rrule])

  const onChangeStartDate = useCallback(
    (startDate: NaiveDateTime, duration: number) => {
      const newRule = new RRule({
        ...rrule.origOptions,
        byhour: startDate.hours,
        byminute: startDate.minutes,
        bysecond: null,
        dtstart: null
      })

      const newRRule = recurences.rruleToApiReadyString(newRule)

      onChange({
        ...value,
        rrule: newRRule,
        startDate: startDate.toString(),
        duration
      })
    },
    [value, rrule, onChange]
  )

  const onChangeRRule = useCallback(
    (rrule: RRule) => {
      const newRRule = recurences.rruleToApiReadyString(rrule)

      onChange({ ...value, rrule: newRRule })
    },
    [value, onChange]
  )

  return (
    <div className="flex flex-col gap-4">
      <RRuleInput rrule={rrule} onChange={onChangeRRule} />
      <RecDate
        startDate={startDate}
        duration={duration}
        isRecurring={rrule.options.count !== 1}
        showUntil={showUntil}
        onChange={onChangeStartDate}
      />
    </div>
  )
}
